/**
 * The Institute's other front ends.
 *
 * One place, because a link that points at the wrong host is the kind of thing
 * that gets fixed in one file and missed in three.
 */

/**
 * The Cost Databank.
 *
 * A separate site on its own subdomain, reading the same API and the same
 * accounts — so a member arrives there already signed in (see
 * components/SessionBridge.tsx), and whether the registers open for them is
 * decided by their dues exactly as it is here.
 *
 * `REACT_APP_DATABANK_SITE_URL` overrides it. Failing that, a portal running on
 * localhost assumes the databank's dev server on port 3100 (its Vite config
 * fixes that port, deliberately clear of the portal's 3000) — otherwise every
 * local click would leave for the live site, which is the one place a developer
 * does not want to be testing.
 */
export const DATABANK_SITE_URL: string =
  process.env.REACT_APP_DATABANK_SITE_URL ||
  (typeof window !== "undefined" &&
  /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)
    ? "http://localhost:3100"
    : "https://costdata.niqsng.org");
